<div class="dialog-header">
    <div class="header-content">
        <div class="title">
            <mat-icon class="header-icon">info</mat-icon>

            <h2 mat-dialog-title class="title">
                {{'viewer.model_info'|translate}}
            </h2>
        </div>

        <lib-button (click)="onCancel()" color="none" textColor="muted" icon="close"
            tooltip="{{'form.close' | translate}}">
        </lib-button>
    </div>
</div>

<mat-dialog-content class="dialog-body">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
        <app-spinner text="{{'viewer.properties.loading' | translate}}"></app-spinner>
    </div>

    <!-- Content -->
    <div *ngIf="!loading" class="content">
        <div class="columns-wrapper">
            <!-- Left Column -->
            <div class="column column-left">
                <ng-container *ngFor="let mapping of mappingArray">
                    <ng-container *ngIf="isLeftColumn(mapping.category)">
                        <div class="section">
                            <div class="section-header">
                                <mat-icon class="section-icon">{{ getIconForCategory(mapping.category) }}</mat-icon>
                                <h3>{{'viewer.properties.' + mapping.category | translate}}</h3>
                            </div>

                            <div class="group">
                                <lib-search-select *ngFor="let name of mapping.names" [items]="allPropertyNames"
                                    [selectedItem]="name.value" [label]="'viewer.properties.' + name.key"
                                    [searchPlaceholder]="'form.search'"
                                    (itemChanged)="name.value = $event; onMappingChanged()" class="search-select">
                                </lib-search-select>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <!-- Right Column -->
            <div class="column column-right">
                <ng-container *ngFor="let mapping of mappingArray">
                    <ng-container *ngIf="!isLeftColumn(mapping.category) && mapping.category !== 'buildingType'">
                        <div class="section">
                            <div class="section-header">
                                <mat-icon class="section-icon">{{ getIconForCategory(mapping.category) }}</mat-icon>
                                <h3>{{'viewer.properties.'+mapping.category | translate}}</h3>
                            </div>

                            <div class="group">
                                <lib-search-select *ngFor="let name of mapping.names" [items]="allPropertyNames"
                                    [selectedItem]="name.value" [label]="'viewer.properties.' + name.key"
                                    [searchPlaceholder]="'form.search'"
                                    (itemChanged)="name.value = $event; onMappingChanged()" class="search-select">
                                </lib-search-select>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Building Types Section -->
                <div class="section">
                    <div class="section-header">
                        <mat-icon class="section-icon">apartment</mat-icon>
                        <h3>{{'viewer.properties.buildingType' | translate}}</h3>
                    </div>

                    <div class="group">
                        <ng-container *ngFor="let mode of buildingTypeMappingArray">
                            <mat-form-field appearance="outline" class="compact-field" subscriptSizing="dynamic" class='search-select'>
                                <mat-label>{{'viewer.properties.'+mode.name | translate}}</mat-label>
                                <mat-select matInput [(ngModel)]="mode.value" name="{{mode.value}}" multiple>
                                    <ng-container *ngFor="let _name of buildingTypes">
                                        <mat-option [value]="_name">{{_name}}</mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <lib-button (click)="onCancel()" text="{{'viewer.close'|translate}}" color="outline" icon="close"></lib-button>
    <lib-button (click)="save()" color="primary" text="{{'viewer.save'|translate}}" icon="done"></lib-button>
</mat-dialog-actions>